import { Amplify } from "aws-amplify";
import { generateClient } from "@aws-amplify/api";

export const createStatusSubscription = async ({
  client,
  requestId,
  userId,
  onMessage,
  onError,
  onComplete,
}) => {
  if (!requestId || !userId) {
    throw new Error(
      "To create appsync subscription requestId and userId are required.",
    );
  }

  const { token, appsyncSubscriptionURL } = await getSubscriptionToken(
    client,
    requestId,
    userId,
  );

  Amplify.configure({
    API: {
      GraphQL: {
        endpoint: appsyncSubscriptionURL,
        region: "us-east-1",
        defaultAuthMode: "lambda",
      },
    },
  });

  const appsyncSubscriptionClient = generateClient();
  const sub = appsyncSubscriptionClient
    .graphql({
      query: onTTSTagMessageStatusSubscription,
      authMode: "lambda",
      authToken: token,
      variables: { requestId },
    })
    .subscribe({
      next: (event) => {
        const status = event?.data?.onTTSTagMessageStatus;

        if (!status) {
          return;
        }
        onMessage(status);
      },
      error: (err) => onError?.(err),
      complete: () => onComplete?.(),
    });

  return { unsubscribe: () => sub.unsubscribe() };
};

const mutationSubscriptionToken = `
  mutation TokenSubscription($requestId: ID!, $userId: ID!) {
    tokenSubscription(requestId: $requestId, userId: $userId) {
      token
      appsyncSubscriptionURL
      expiresAt
    }
  }`;

const getSubscriptionToken = async (client, requestId, userId) => {
  try {
    const response = await client
      .mutation(
        mutationSubscriptionToken,
        { requestId, userId },
        { requestPolicy: "network-only" },
      )
      .toPromise();

    if (response?.error) {
      throw response.error instanceof Error
        ? response.error
        : new Error(response.error);
    }

    return response?.data?.tokenSubscription;
  } catch (e) {
    if (/Token has expired\./.test(e.toString()))
      window.location.replace("/logout.html");

    throw e;
  }
};

const onTTSTagMessageStatusSubscription = `
  subscription OnTTSTagMessageStatus($requestId: ID) {
    onTTSTagMessageStatus(requestId: $requestId) {
      __typename
      requestId
      timestamp
      status
      details
      tagId
    }
  }
`;
